import { Loader } from '../utils/loader'
import { SERVICES } from '../config/constants'

class ImporterLoader extends Loader {
}

export const importerLoader = new ImporterLoader({
  service: SERVICES.res
})
